"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.textDisabledColor = exports.textSecondaryColor = exports.textPrimaryColor = exports.getRandomColor = exports.RANDOM_BACKGROUND_COLOR_ARRAY = void 0;
// Orange
var pumpkin = {
  100: '#FFBA8F',
  200: '#FFA670',
  300: '#FC9252',
  400: '#F7823B',
  500: '#E67028',
  600: '#C75F20',
  700: '#B24F12'
}; // Light Orange

var orange = {
  100: '#FCD6A5',
  200: '#FBC783',
  300: '#FAB760',
  400: '#F9A83E',
  500: '#F7981C',
  600: '#E78B12',
  700: '#D37A04'
}; // Yellow

var banana = {
  100: '#FBF7E0',
  200: '#FFF0B3',
  300: '#FFE380',
  400: '#F7CB53',
  500: '#FFC400',
  600: '#FFBB00',
  700: '#E6A900'
}; // Green

var kiwi = {
  100: '#86D592',
  200: '#68C576',
  300: '#3CAC56',
  400: '#338E40',
  500: '#2A8337',
  600: '#24672D',
  700: '#15581E'
}; // Mint

var mint = {
  100: '#E5F2F2',
  200: '#A0ECE5',
  300: '#44D9CD',
  400: '#00CCBB',
  500: '#00B8A9',
  600: '#00A294',
  700: '#006159'
}; // Liva

var liva = {
  100: '#CCF6F7',
  200: '#A8E8EA',
  300: '#71CDD1',
  400: '#49B1B7',
  500: '#2A9599',
  600: '#0F898D',
  700: '#0A676A'
}; // Light Blue

var mermaid = {
  100: '#A4E8F7',
  200: '#86D3E5',
  300: '#57BCD4',
  400: '#34A9C4',
  500: '#1597B5',
  600: '#05748F',
  700: '#095567'
}; // Blue

var blueberry = {
  100: '#94CEF8',
  200: '#5FAEE7',
  300: '#328FD2',
  400: '#3681C2',
  500: '#3C6CAB',
  600: '#295288',
  700: '#143561'
}; // Plum

var plum = {
  100: '#D2EAFF',
  200: '#A4D1FF',
  300: '#569DFF',
  400: '#1E74FF',
  500: '#1559DB',
  600: '#0F42B7',
  700: '#05207A'
}; // Dark Purple

var fig = {
  100: '#DCB2E6',
  200: '#CA93D8',
  300: '#A860BA',
  400: '#8C3DA0',
  500: '#7A2490',
  600: '#611275',
  700: '#3F0B4C'
}; // Light Purple

var dragon = {
  100: '#FFC0FA',
  200: '#F6A8F0',
  300: '#DA73D2',
  400: '#C64BBD',
  500: '#9E158F',
  600: '#900F76',
  700: '#5E004B'
}; // Red

var strawberry = {
  100: '#FFEBE6',
  200: '#FFBDAD',
  300: '#FF7161',
  400: '#FF312D',
  500: '#DB202D',
  600: '#B7162F',
  700: '#930E2E'
}; // Dark Red

var cherry = {
  100: '#F5C2CB',
  200: '#F99EAE',
  300: '#F47187',
  400: '#EC4E67',
  500: '#D92945',
  600: '#AD102B',
  700: '#851528'
}; // White

var lychee = {
  100: '#FFFFFF',
  200: '#F1F4F7',
  300: '#E8EDF2',
  400: '#E0E6ED',
  500: '#D8E0EA',
  600: '#CED8E3',
  700: '#C5D0DE'
}; // Black

var blackberry = {
  100: '#8F96A1',
  200: '#687488',
  300: '#4A576E',
  400: '#333F52',
  500: '#111F37',
  600: '#051022',
  700: '#000000'
};
var RANDOM_BACKGROUND_COLOR_ARRAY = [banana[400], blueberry[400], cherry[400], dragon[400], fig[400], kiwi[400], mermaid[400], mint[400], orange[400], pumpkin[400], strawberry[400]];
exports.RANDOM_BACKGROUND_COLOR_ARRAY = RANDOM_BACKGROUND_COLOR_ARRAY;

var getRandomColor = function getRandomColor() {
  return RANDOM_BACKGROUND_COLOR_ARRAY[Math.floor(Math.random() * (RANDOM_BACKGROUND_COLOR_ARRAY.length - 1))];
};

exports.getRandomColor = getRandomColor;
var textPrimaryColor = blackberry[400];
exports.textPrimaryColor = textPrimaryColor;
var textSecondaryColor = blackberry[200];
exports.textSecondaryColor = textSecondaryColor;
var textDisabledColor = blackberry[100];
exports.textDisabledColor = textDisabledColor;
var _default = {
  pumpkin: pumpkin,
  orange: orange,
  banana: banana,
  kiwi: kiwi,
  mint: mint,
  liva: liva,
  mermaid: mermaid,
  blueberry: blueberry,
  plum: plum,
  fig: fig,
  dragon: dragon,
  strawberry: strawberry,
  cherry: cherry,
  lychee: lychee,
  blackberry: blackberry
};
exports["default"] = _default;